import { useLang } from 'hooks/lang';

import { Column, Button } from 'components/Blocks';
import { ArrowLeftIcon } from 'components/Icons';

export function NoActions() {
  const { t } = useLang();

  return (
    <Column justifyContent="center" alignItems="center">
      <h5 className="text-3xl text-primary">{t('no-pending-actions')}</h5>

      <Button to="home">
        <ArrowLeftIcon />
        Home
      </Button>
    </Column>
  );
}
